import costuto from '@/apis/costuto.js'
import helpers from '@/store/helpers.js'
import axios from 'axios'

const state = {
}

const getters = {
}

const actions = {
  create: ({ dispatch }, payload) => {
    let data = helpers.dataFormat('confirmation', { confirmation_token: payload })
    return new Promise((resolve, reject) => {
      costuto().post('confirmations', data)
        .then(resp => {
          const user = JSON.parse(resp.data.user).data
          const token = resp.data.token
          localStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
          dispatch('setup', { user, token }, { root: true })
          resolve(user.attributes.username)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
